import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder"
import { TicketData } from "@/common/types/support/ticket.type"
import { formatDateTime } from "@/common/utils/formatters"
import { UserRoundIcon } from "lucide-react"

interface LastVieweDataProps {
  supportTicket: TicketData
}

export default function LastVieweData({supportTicket}: LastVieweDataProps) {
 const formattedDateTime = formatDateTime(new Date(supportTicket.company_last_viewed_at))
  const lastViewedBy = supportTicket?.company_last_viewed_by

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-bold">Histórico de visualização</h2>

      <div className="flex items-center gap-2">
        <p className="text-sm">Visto por último por</p>
        <ImageWithPlaceholder
          url={lastViewedBy.profile_picture?.url}
          alt={lastViewedBy.full_name}
          placeholderIcon={UserRoundIcon}
          className="size-6"
          iconClassName="size-6"
          />
        <p className="text-sm">{lastViewedBy.full_name}</p>
        <p className="text-sm">no dia {formattedDateTime}</p>
      </div>
    </div>
  )
}
